import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "parts", "arrow"]

  toggle() {
    const open = this.partsTarget.style.display === "none"
    this.partsTarget.style.display = open ? "" : "none"
    this.arrowTarget.style.transform = open ? "rotate(180deg)" : "rotate(0deg)"
    this.toggleTarget.setAttribute("aria-expanded", String(open))
  }
}
